/**
 * Client configuration, resolved once from Vite's build-time env.
 *
 * Anything here is public — it ships in the JS bundle. Secrets belong in the
 * server workspace.
 */

const env = import.meta.env;

const number = (value, fallback) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

/**
 * The anchor point: shown in the location bar, centres the map, and biases
 * discovery when nobody has shared a location.
 *
 * Columbus, because that is the market being opened and where the waitlist is
 * being collected. These are only the fallbacks — `VITE_VENUE_*` overrides them
 * — but a fallback pointing at the wrong city is how a deck ends up quietly
 * full of restaurants five hundred miles away.
 */
export const venue = {
  label: env.VITE_VENUE_LABEL || 'Columbus',
  lat: number(env.VITE_VENUE_LAT, 39.9612),
  lng: number(env.VITE_VENUE_LNG, -82.9988),
};

/** @type {[number, number]} Leaflet-style coordinate pair. */
export const venueCoords = [venue.lat, venue.lng];

/** Google Identity Services client id — public by design, no client secret involved. */
export const googleClientId = env.VITE_GOOGLE_CLIENT_ID || '';

export const firebaseConfig = {
  apiKey: env.VITE_FIREBASE_API_KEY || '',
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN || '',
  databaseURL: env.VITE_FIREBASE_DATABASE_URL || '',
  projectId: env.VITE_FIREBASE_PROJECT_ID || '',
  appId: env.VITE_FIREBASE_APP_ID || '',
};

/** True when there is enough config to attempt a Realtime Database connection. */
export const isFirebaseConfigured = Boolean(firebaseConfig.apiKey && firebaseConfig.databaseURL);

/**
 * Public origin used to build group-invite links and QR codes. Falls back to
 * wherever the page is currently served from, which is right for local dev.
 */
export const publicUrl = env.VITE_PUBLIC_URL || window.location.origin;

/**
 * Where "Get the app" points.
 *
 * Empty until there is somewhere public to send people. Set it to the
 * TestFlight invite while in beta, then the App Store listing at launch.
 */
export const APP_DOWNLOAD_URL = (import.meta.env.VITE_APP_DOWNLOAD_URL ?? '').trim();
